/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Input_Position_Dialog_ValidatorInputs */



/**
* | output |
* | --- |
* | "Please enter a number between 1 and {max}" |
*
* @param {Input_Position_Dialog_ValidatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_dialog_validator = /** @type {((inputs: Input_Position_Dialog_ValidatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Dialog_ValidatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Veuillez entrer un nombre entre 1 et ${i?.max}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitte geben Sie eine Zahl zwischen 1 und ${i?.max} ein.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inserisci un numero compreso tra 1 e ${i?.max}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пожалуйста, введите число от 1 до ${i?.max}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Por favor, introduzca un número entre 1 y ${i?.max}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`请输入 1 到 ${i?.max} 之间的数字`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`1から${i?.max}までの数字を入力してください`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कृपया 1 और ${i?.max} के बीच एक संख्या दर्ज करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Por favor, insira um número entre 1 e ${i?.max}`)
	return /** @type {LocalizedString} */ (`Please enter a number between 1 and ${i?.max}`)
});